import type {AddComponentTypeOptions} from 'grapesjs';
import {createBaseInputComponent} from '@FormMakerReact/components/create-base-input-component';
import {FORM_INPUT_STYLES} from '@FormMakerReact/components/component-styles';

export const POSTERMYWALL_NAME_INPUT_TYPE = 'postermywall-name-input';

export const POSTERMYWALL_NAME_INPUT: AddComponentTypeOptions = createBaseInputComponent({
  inputFieldType: POSTERMYWALL_NAME_INPUT_TYPE,
  inputName: 'name',
  dataMarkerAttribute: 'data-is-pmw-form-name-input',
  displayName: 'First Name',
  placeholder: 'Enter your first name here',
  style: FORM_INPUT_STYLES,
  isComponentCheck: (el) => el.getAttribute('data-is-pmw-form-name-input') !== null,
});
